import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-advertiserUpload',
    templateUrl: './advertiserUpload.component.html',
  providers: [ SharedService,PopupSegmentComponent]
 
})
export class AdvertiserUploadComponent implements OnInit {
  advertiserUploadForm:FormGroup;
  fileData : any;
  successMessage : string;
    constructor(private localstorage: LocalStorage,
      private loaderService: LoaderService,
      private formBuilder: FormBuilder,
      private shareService: SharedService,
      private router: Router) {
    
    }

ngOnInit() {
  this.advertiserUploadForm = this.formBuilder.group({
    csvFile: ['', Validators.required]
  });
}

   
selectFile(files: FileList){
  console.log(files);
  if(files && files.length > 0) {
    let file : File = files.item(0); 
    this.fileData = file;
      // console.log(file.name);
      // console.log(file.size);
      // console.log(file.type);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
         let csv: string = reader.result as string;
         console.log(csv);
      }
   }

   
}
   

uploadAdvertiser(){
  console.log(this.fileData);
  let formData: FormData = new FormData();
  var token = this.localstorage.getStorage("token");
  formData.append('csvFile', this.fileData)
  this.shareService.callApiWithTokenMultipart("master/postAdvertiserCsv", formData, token).subscribe((result) => {
    if(result.data ){
      this.successMessage = "CSV uploaded successfully.";
      }
    });
}

}



// WEBPACK FOOTER //
// ./src/app/admin/layout/advertiserUpload/advertiserUpload.component.ts